(function () {
  'use strict';

  var CFG = window.ACG_CONFIG || {};
  var SESSION_KEY = 'acg_age_ok';
  // Datos capturados antes del login. Se guardan aqui y NO en la URL: el
  // documento de identidad es un dato personal y en la query string quedaria
  // en el historial, en los logs del servidor y en el header Referer hacia
  // terceros. sessionStorage vive solo en la pestana del usuario.
  var PENDING_KEY = 'acg_pending_profile';

  var root = document.getElementById('AgeCedulaGate');
  if (!root) return;

  var form = root.querySelector('[data-acg-form]');
  var statusEl = root.querySelector('[data-acg-status]');
  var submitBtn = root.querySelector('[data-acg-submit]');
  var introEl = root.querySelector('[data-acg-intro]');
  var birthInput = form.querySelector('[name="birthdate"]');
  var cedulaInput = form.querySelector('[name="cedula"]');
  var doctypeSelect = form.querySelector('[name="document_type"]');
  var helpEl = form.querySelector('[data-acg-help]');

  // Reglas compartidas con el formulario de la cuenta.
  var DOC = window.DislicoresDocument;

  // El modal es siempre descartable: solo se muestra antes del registro, y el
  // registro real ocurre fuera del tema (Shopify), asi que no tendria sentido
  // bloquear. A un cliente ya registrado nunca se le interrumpe.
  var pendingHref = null;

  // -- Validaciones ----------------------------------------------
  function currentDocType() {
    return doctypeSelect ? doctypeSelect.value : '';
  }

  function cleanNuipValue(value) {
    return DOC.clean(value, currentDocType());
  }

  function validateColombiaNuip(value) {
    return DOC.validateNumber(value, currentDocType());
  }

  // Edad cumplida a dia de hoy, comparando mes y dia para no contar de mas.
  function calcAge(isoDate) {
    var parts = String(isoDate || '').split('-');
    if (parts.length !== 3) return null;

    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;

    var birth = new Date(y, m - 1, d);
    if (birth.getFullYear() !== y || birth.getMonth() !== m - 1 || birth.getDate() !== d) {
      return null;
    }

    var today = new Date();
    if (birth > today) return null;

    var age = today.getFullYear() - y;
    var monthDiff = today.getMonth() - (m - 1);
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < d)) age--;

    return age;
  }

  function validateBirthdate(value) {
    var minAge = CFG.minAge || 18;

    if (!value) {
      return { valid: false, message: 'Ingresa tu fecha de nacimiento.' };
    }

    var age = calcAge(value);
    if (age === null) {
      return { valid: false, message: 'Ingresa una fecha de nacimiento valida.' };
    }
    if (age < minAge) {
      return { valid: false, message: 'Debes ser mayor de ' + minAge + ' anos para continuar.' };
    }
    if (age > 120) {
      return { valid: false, message: 'Ingresa una fecha de nacimiento valida.' };
    }
    return { valid: true, message: '' };
  }

  // -- UI --------------------------------------------------------
  function setFieldError(input, message) {
    var field = input.closest('.acg__field');
    var error = field ? field.querySelector('.acg__error') : null;

    if (field) field.classList.toggle('has-error', !!message);
    if (error) error.textContent = message || '';
  }

  function setStatus(message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  function open(options) {
    var opts = options || {};
    pendingHref = opts.href || null;

    root.hidden = false;
    document.body.style.overflow = 'hidden';

    if (introEl) {
      introEl.textContent = 'Para continuar necesitamos confirmar que eres mayor de edad.';
    }

    var focusTarget = birthInput.value ? cedulaInput : birthInput;
    setTimeout(function () { focusTarget.focus(); }, 50);
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
    setStatus('');
  }

  // -- Persistencia ----------------------------------------------
  // Solo con sesion iniciada: sin customer no hay a quien asociar los datos.
  function saveToBackend(payload) {
    var url = CFG.endpoint + '?logged_in_customer_id=' + encodeURIComponent(CFG.customerId);

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.text().then(function (raw) {
        var data = null;
        try { data = raw ? JSON.parse(raw) : null; } catch (e) { /* respuesta no JSON */ }

        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.message) || 'No pudimos guardar tus datos. Intenta de nuevo.');
        }
        return data;
      });
    });
  }

  // -- Submit ----------------------------------------------------
  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var birthCheck = validateBirthdate(birthInput.value);
    var typeCheck = DOC.validateType(currentDocType());
    // El numero se valida contra el tipo, asi que el tipo va primero.
    var nuipCheck = validateColombiaNuip(cedulaInput.value);

    setFieldError(birthInput, birthCheck.valid ? '' : birthCheck.message);
    if (doctypeSelect) setFieldError(doctypeSelect, typeCheck.valid ? '' : typeCheck.message);
    setFieldError(cedulaInput, nuipCheck.valid ? '' : nuipCheck.message);

    if (!birthCheck.valid) { birthInput.focus(); return; }
    if (!typeCheck.valid) { if (doctypeSelect) doctypeSelect.focus(); return; }
    if (!nuipCheck.valid) { cedulaInput.focus(); return; }

    cedulaInput.value = nuipCheck.value;

    // Sin sesion no hay persistencia posible; se marca la verificacion en la
    // sesion del navegador y se sigue al login/registro de Shopify.
    if (!CFG.isLoggedIn) {
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({
          document_type: typeCheck.value,
          cedula: nuipCheck.value,
          birthdate: birthInput.value
        }));
      } catch (e) { /* modo privado */ }

      window.location.href = CFG.loginUrl || pendingHref;
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Guardando...';
    setStatus('Guardando tus datos...');

    saveToBackend({
      document_type: typeCheck.value,
      cedula: nuipCheck.value,
      birthdate: birthInput.value
    }).then(function () {
      setStatus('Listo. Gracias por confirmar.');
      clearPending();
      close();
      window.location.reload();
    }).catch(function (error) {
      setStatus(error.message || 'No pudimos guardar tus datos.', true);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Continuar';
    });
  });

  // El texto de ayuda y el maxlength dependen del tipo elegido.
  function syncDocTypeUI() {
    var rule = DOC.getRule(currentDocType());

    if (helpEl) helpEl.textContent = currentDocType() ? rule.help : '';

    cedulaInput.setAttribute('maxlength', String(rule.max));
    cedulaInput.setAttribute('inputmode', rule.kind === 'numeric' ? 'numeric' : 'text');
  }

  if (doctypeSelect) {
    doctypeSelect.addEventListener('change', function () {
      // Pasar de pasaporte a cedula debe descartar las letras ya escritas.
      cedulaInput.value = DOC.clean(cedulaInput.value, currentDocType());
      syncDocTypeUI();
      setFieldError(doctypeSelect, '');
      setFieldError(cedulaInput, '');
    });

    syncDocTypeUI();
  }

  cedulaInput.addEventListener('input', function () {
    cedulaInput.value = cleanNuipValue(cedulaInput.value);
    setFieldError(cedulaInput, '');
  });

  birthInput.addEventListener('input', function () {
    setFieldError(birthInput, '');
  });

  root.querySelector('[data-acg-close]').addEventListener('click', close);
  root.querySelector('[data-acg-backdrop]').addEventListener('click', close);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) close();
  });

  function readPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || (!parsed.cedula && !parsed.birthdate && !parsed.document_type)) return null;

      return parsed;
    } catch (e) {
      return null;
    }
  }

  function clearPending() {
    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) { /* modo privado */ }
  }

  // -- Disparadores ----------------------------------------------
  // 1. Pre-registro: intercepta el boton de cuenta del header cuando no hay
  //    sesion. Si ya verifico la edad en esta sesion, no se vuelve a pedir.
  if (!CFG.isLoggedIn) {
    var verified = false;
    try { verified = sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { /* modo privado */ }

    if (!verified) {
      document.addEventListener('click', function (event) {
        var link = event.target.closest('.account-button');
        if (!link) return;

        event.preventDefault();
        open({ href: link.getAttribute('href') });
      });
    }
  }

  // 2. Post-login: NO se muestra el modal. El popup es solo para quien va a
  //    registrarse; a un cliente ya registrado no se le interrumpe la
  //    navegacion aunque le falten datos (esos se completan en /pages/cuenta).
  //
  //    Lo unico que ocurre aqui es guardar en silencio lo que el usuario ya
  //    escribio antes de ir al login: vuelve autenticado y sus datos se
  //    persisten solos, sin volver a pedirselos ni mostrar nada.
  if (CFG.isLoggedIn) {
    var pending = readPending();

    if (pending && (!CFG.hasCedula || !CFG.hasBirthdate || !CFG.hasDocType)) {
      // Se validan contra las mismas reglas del formulario antes de enviarlos;
      // el modal permanece cerrado en todo el proceso.
      var pendingType = DOC.validateType(pending.document_type);
      var pendingBirth = validateBirthdate(pending.birthdate);
      var pendingNumber = pendingType.valid
        ? DOC.validateNumber(pending.cedula, pendingType.value)
        : { valid: false, value: '' };

      if (pendingType.valid && pendingBirth.valid && pendingNumber.valid) {
        saveToBackend({
          document_type: pendingType.value,
          cedula: pendingNumber.value,
          birthdate: pending.birthdate
        }).then(function () {
          clearPending();
          // Recarga para que Liquid vuelva a leer los metacampos ya guardados.
          window.location.reload();
        }).catch(function (error) {
          // Si falla no se molesta al usuario: los datos quedan pendientes y
          // podra completarlos desde su cuenta.
          console.warn('[age-cedula-gate] No se pudieron guardar los datos pendientes.', error);
          clearPending();
        });
      } else {
        clearPending();
      }
    }
  }
})();
